import {
  Icon,
  LoadingCircle,
  ResponsiveGrid,
} from '@gplibraries/react/components';
import { useQuickLinks } from '@gplibraries/react/hooks';
import { iconMap } from '@gplibraries/react/config';
import { Link } from 'react-router';

export default function ResourceTabsSearchResults(props) {

  const { resources, categories, className = '' } = props;
  const { quickLinks, addQuickLink, removeQuickLink, inProgress } = useQuickLinks();

  return (

    <div className={`resource-content-container ${className}`}>

      <div className="resource-content flex-col">

        <ResponsiveGrid minColumnWidth={'max(260px, 32%)'}  className={'start'} gap={'1rem'}>

          {(categories?.length > 0 && resources?.length > 0) && categories
            // Only show parent categories applicable to the links that match the search query
            .filter(category => resources.some(resource => resource?.category?.some(c => c.parent?.id === category.id)))
            .sort((a, b) => a.weight - b.weight)
            .map(category =>

              <div key={category.id} className={'resource-group'}>

                <div className="resource-group-name">
                  <h3>
                    <Icon
                      glyph={iconMap.categories[category.id]?.glyph}
                      src={iconMap.categories[category.id]?.src}
                    />
                    {category.name}
                  </h3>
                </div>

                <ul className="no-marker">
                  {resources
                    // grouping & rendering query-matched links by top-level category
                    .filter(resource => resource?.category?.map(c => c.parent.id).includes(category.id))
                    .map(resource => (
                      <li key={resource.id} className={'resource-link flex-row'}>
                        {quickLinks.find(item => item.id === resource.id)
                          ? (
                            <button
                              className="icon-only"
                              onClick={() => removeQuickLink(resource.id)}>
                              {inProgress === resource.id ? <LoadingCircle/> :
                                <Icon glyph={'dash-square-fill'}/>}
                            </button>
                          ) : (
                            <button
                              className="icon-only"
                              onClick={() => addQuickLink(resource.id, resource.type)}>
                              {inProgress === resource.id ? <LoadingCircle/> :
                                <Icon glyph={'plus-square'}/>}
                            </button>
                          )
                        }
                        <Link to={resource.field_url} reloadDocument={true}>{resource.title}</Link>
                      </li>
                    ))
                  }
                </ul>
              </div>)
          }

          {resources.length == 0 &&
            <div className={'search-fallback message flex-row'}>Sorry, we
              couldn't find what you are looking for.</div>
          }

        </ResponsiveGrid>

      </div>
    </div>
  );
}